export function OutlineFemaleIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8173 14.6346C15.0301 14.6346 17.6346 12.0301 17.6346 8.81728C17.6346 5.60449 15.0301 3 11.8173 3C8.60449 3 6 5.60449 6 8.81728C6 12.0301 8.60449 14.6346 11.8173 14.6346Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M11.8171 14.6348V21.42"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M8.90869 18.5098H14.726"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
